export const responseAmazonDSPSubscription = {
  data: {
    type: 'Subscription',
    id: '265',
    attributes: {
      price: 0,
      status: 'active',
      date_start: '2022-01-10T19:51:54',
      date_end: '2022-01-10T19:51:54',
      auto_renew: 1,
      created_at: '2022-01-10T19:51:59.573723',
      modified_at: '2022-01-10T19:51:59.573738',
      quantity: 1,
      stripe_subscription_id: '',
      name: 'amazon-dsp-mock-1',
      rabbit_payload_successful: 0,
      primary_job_id: null,
      pipeline: null,
      invalid_subscription: 0,
      invalidated_at: null,
      notified_at: null,
      canonical_name: null,
      account_id: 342,
      product_id: 54,
      product_plan_id: null,
      remote_identity_id: 22,
      storage_group_id: 88,
      user_id: 309,
      history_requested: 0
    },
    relationships: {
      account: {
        data: {
          type: 'Account',
          id: '342'
        }
      },
      product: {
        data: {
          type: 'Product',
          id: '54'
        }
      },
      product_plan: {
        data: null
      },
      remote_identity: {
        data: {
          type: 'RemoteIdentity',
          id: '22'
        }
      },
      storage_group: {
        data: {
          type: 'StorageGroup',
          id: '88'
        }
      },
      user: {
        data: {
          type: 'User',
          id: '309'
        }
      }
    }
  },
  included: [
    {
      type: 'StorageGroup',
      id: '88',
      attributes: {
        product_id: 52,
        name: 'snowflake',
        key_name: 'snowflake-342'
      }
    }
  ]
};